import React from 'react';
import { Link } from 'react-router-dom';
import { allProductsData } from '../data/products';
import './ProductsList.css'; // Reusing consistency
import './RelatedProducts.css';

const RelatedProducts = ({ currentProductId }) => {
    // Filter out the currently viewed product, and just take the first 3 for display (matching the 3-column layout)
    const relatedItems = allProductsData
        .filter(product => product.id !== currentProductId)
        .slice(0, 3);

    return (
        <section className="related-products-section">
            <div className="products-list-container">

                <div className="products-list-header">
                    <div className="products-header-left">
                        <span className="section-subtitle">EQUIPMENT</span>
                        <h2 className="products-main-title">
                            Related Physiotherapy<br />
                            Equipment
                        </h2>
                    </div>
                    <div className="products-header-right">
                        <Link to="/products" className="view-all-btn">
                            VIEW ALL PRODUCTS
                        </Link>
                    </div>
                </div>

                <div className="products-grid-wrapper">
                    {relatedItems.map(product => {
                        const heightRange = product.specs.find(s => s.label.includes('HEIGHT'))?.value || 
                                           product.detailedSpecs?.find(s => s.label.includes('Height'))?.value;

                        return (
                            <Link to={`/product/${product.slug || product.id}`} className="product-card-vertical" key={product.id} style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className="product-image-wrapper">
                                    <div className="product-image-container">
                                        <img src={product.image} alt={product.title} />
                                    </div>
                                    <div className="view-icon-btn" aria-label={`View details for ${product.title}`}>
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="7" y1="17" x2="17" y2="7"></line>
                                            <polyline points="7 7 17 7 17 17"></polyline>
                                        </svg>
                                    </div>
                                </div>
                                
                                <div className="product-details-content">
                                    <div className="product-details-header">
                                        <h3 className="product-name">{product.title}</h3>
                                        {heightRange && (
                                            <div className="height-range-info">
                                                <span className="info-label">Height Range</span>
                                                <span className="info-value">{heightRange.split('[cite:')[0]}</span>
                                            </div>
                                        )}
                                    </div>
                                    
                                    <ul className="product-features-list">
                                        {(product.keyFeatures || []).slice(0, 5).map((feature, idx) => (
                                            <li key={idx}>
                                                <span className="bullet">•</span>
                                                {feature.split('[cite:')[0].trim()}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Link>
                        );
                    })}
                </div>

            </div>
        </section>
    );
};

export default RelatedProducts;
